import React from 'react';
import Accessible from '@material-ui/icons/Accessible'
import Pets from '@material-ui/icons/Pets'
import ChildFriendly from '@material-ui/icons/ChildFriendly'
import DirectionsBike from '@material-ui/icons/DirectionsBike'
import AirportShuttle from '@material-ui/icons/AirportShuttle'
import GolfCourse from '@material-ui/icons/GolfCourse'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import LocalHospital from '@material-ui/icons/LocalHospital'
import Grade from '@material-ui/icons/Grade'
import Spellcheck from '@material-ui/icons/Spellcheck'
import LocalParking from '@material-ui/icons/LocalParking'
import Redo from '@material-ui/icons/Redo'
import { TeddyBear } from "../../../images/teddyBear";
import { Grid } from '@material-ui/core';
import _ from 'lodash';
import { IdCard } from '../../../images/idCard';

//true value is 2 //false value is 1
const facts = [
  {code: 'AVIH', isUnique: false, icon: <span style={{width: '32px'}}><Pets style={{width: '18px'}} />H</span>},
  {code: 'CATT', isUnique: true, icon: <Spellcheck /> },
  {code: 'GOLF', isUnique: false, icon: <GolfCourse /> },
  {code: 'HLTH', isUnique: true, icon: <LocalHospital /> },
  {code: 'PVSH', isUnique: true, icon: <LocalParking /> },
  {code: 'VIP', isUnique: false, icon: <Grade /> },
  {code: 'VTST', isUnique: true, icon: <VerifiedUser /> },
  {code: 'PETC', isUnique: false, icon: <span style={{width: '32px'}}><Pets style={{width: '18px'}} />C</span> },
  {code: 'INFT', isUnique: true, icon: <ChildFriendly /> },
  {code: 'WCxx', isUnique: false, icon: <Accessible /> },
  {code: 'WCHS', isUnique: false, icon: <Accessible /> },
  {code: 'WCHR', isUnique: false, icon: <Accessible /> },
  {code: 'WCHC', isUnique: false, icon: <Accessible /> },
  {code: 'UMNR', isUnique: false, icon: <TeddyBear /> },
  {code: 'SHTL', isUnique: true, icon: <AirportShuttle /> },
  {code: 'BIKE', isUnique: false, icon: <DirectionsBike /> },
  {code: 'SPET', isUnique: false, icon: <span style={{width: '32px'}}><Pets style={{width: '18px'}} />S</span>},
  {code: 'THRU',isUnique: false, icon: <Redo/>},
  {code: 'FQTV',isUnique: false, icon:<IdCard/>}
];

const SSRItem = (props) => {
  const { item, index, key, isMobile } = props

  if (isMobile) {
    return <SSRMobileItem item={item} index={index} key={key} />
  }
  else {
    return <SSRDesktopItem item={item} index={index} key={key} />
  }
}

const SSRDesktopItem = (props) => {
  const { item, index, key } = props
  let isFirst = index === 0 || (index/3) === Math.floor(index/3)
  let isSecond = index === 1 || (index/4) === Math.floor(index/4)

  if (isFirst) {
    return <Grid container justifyContent='flex-end' item xs={4} key={key}>{item}</Grid>
  }
  else if(isSecond) {
    return <Grid container justifyContent='center' item xs={4} key={key}>{item}</Grid>
  }
  else {
    return <Grid container justifyContent='flex-start' item xs={4} key={key}>{item}</Grid>
  }
}

const SSRMobileItem = (props) => {
  const { item, index, key } = props
  let isFirst = index === 0 || index % 2 === 0

  if (isFirst) {
    return (
      <Grid container justifyContent="flex-end" item xs={6}>
        <Grid container justifyContent='center' item xs={11} key={key}>{item}</Grid>
      </Grid>
    )
  }
  else {
    return (
      <Grid container justifyContent="center" item xs={6}>
        <Grid item xs={1}></Grid>
        <Grid container justifyContent='center' item xs={11} key={key}>{item}</Grid>
      </Grid>
    )
  }
}

export const FormattedSSRs = (props) => {
  let output = [];
  let keys = [];
  let paxCopy = _.cloneDeep(props.pax);
  let isMobile = props.isMobile
  let factsArr = facts.map(fact => fact.code)

  // NOTE // looping over properties in pax object
  for (let key in paxCopy) {
    let factLoc = factsArr.indexOf(key)
    // NOTE // if the key is a fact (e.g. 'PVSH': "1")
    if (factLoc !== -1) {
      let curFact =  paxCopy[key]
      // NOTE // some facts can have multiples (e.g. 'PETC': "2")
      let curFactNum = Number(curFact)
      let hasFact = curFactNum > 0
      if (hasFact || key==="FQTV") {
        console.log("CurFact"+curFact+"Key"+key);
        if ((facts[factLoc].isUnique === false && curFactNum > 1)||(key==="FQTV" && curFact ==="")) {
          for (let i = 0; i < curFactNum; i++) {
            keys.push((paxCopy.FirstName + paxCopy.LastName + key + i))
            output.push(facts[factLoc].icon)
          }
        }
        else {
          console.log("CurFact In else"+curFact+"Key"+key);
          console.log("Key in Else"+key);
          keys.push(paxCopy.FirstName + paxCopy.LastName + key + 0)
          output.push(facts[factLoc].icon)
        }
      }
    }
  }

  return (
    <Grid container style={{fontSize: 'small'}}>
      {
        output.map((item, index) => {
          return (
            <SSRItem item={item} index={index} key={keys[index]} isMobile={isMobile} />
          )
        })
      }
    </Grid>
  )
}